import { useReducer } from 'react';
import { addFilesToUploadQueueActionType, addFilesToUploadQueueHandler, addFilesToUploadQueueAction } from './actions/addFilesToUploadQueue';
import { setFileStatusActionType, setFileStatusHandler, setFileStatusAction } from './actions/setFileStatus';
import { clearFinishedActionType, clearFinishedHandler, clearFinishedAction } from './actions/clearFinished';
import { setDirectoryInputActionType, setDirectoryInputHandler, setDirectoryInputAction } from './actions/setDirectoryInput';

const initialState = {
    queue: [],
    isDirectoryInput: false,
}

let actionTypes = [];

actionTypes[addFilesToUploadQueueActionType] = {
    handler: addFilesToUploadQueueHandler,
    action: addFilesToUploadQueueAction,
};
export { addFilesToUploadQueueAction }

actionTypes[setFileStatusActionType] = {
    handler: setFileStatusHandler,
    action: setFileStatusAction,
};
export { setFileStatusAction }

actionTypes[clearFinishedActionType] = {
    handler: clearFinishedHandler,
    action: clearFinishedAction,
};
export { clearFinishedAction }

actionTypes[setDirectoryInputActionType] = {
    handler: setDirectoryInputHandler,
    action: setDirectoryInputAction,
};
export { setDirectoryInputAction }

export function useUploaderReducer() {
    return useReducer(reducer, initialState);
}

function reducer(state, action) {
    const actionType = actionTypes[action.type];
    const actionHandler = actionType ? actionType.handler : null;
    if (actionHandler) {
        return actionHandler(state, action);
    }
    throw new Error('uploaderReducer has no action type: ' + action.type);
}
